<template>
  <div class="card">
    <div class="card-body">
      <h3>What is StreamTales?</h3>
      <p class="intro mb-4">
        StreamTales is a Twitch extension for broadcasters who wants to engage with their community.
        Together with your community, you can create exciting stories about the stream or every other topic. Each story consists of 10 paragraphs which can be added by everyone. The best part is, that every story can be read out via Text-To-Speech.
<br/><br/>
        Optionally you can set a Bits amount for creating new stories or paragraphs.<br/>
        A chat notification will be displayed whenever someone adds a new story or paragraph.<br/>
      </p>
      <div class="embed-responsive embed-responsive-16by9">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/jF_5RtabUMQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div class="text-center installnow mt-4">
        <a class="btn btn-lg btn-primary installBtn" href="https://www.twitch.tv/ext/swrmashg71zls65qlvzmq3ml2o8e3u" target="_blank">Install on Twitch</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.installnow a{
font-size: 32px;
}

p.intro{
  font-size: 22px;
}

.installBtn {
  margin: 40px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue